module.exports = __webpack_public_path__ + "img/pin.b71e7fa9.svg";